export const selectFormattedFiltersForApi = (state) => {
  const { serviceRequestDashboardFilters } = state;
  return {
    WalkthroughPermissions: serviceRequestDashboardFilters.booleanFilters?.filter(
      (a) => a === "Internal" || a === "Homeowner or Occupant",
    ),
    WalkthroughType: serviceRequestDashboardFilters.booleanFilters?.includes(
      "Regular Service Requests",
    )
      ? "Regular Service Requests"
      : null,
    OnlyTarionServiceRequests: serviceRequestDashboardFilters.booleanFilters?.includes("Imported")
      ? true
      : null,
    OnlyGroupedServiceRequests: serviceRequestDashboardFilters.booleanFilters?.includes("Grouped")
      ? true
      : null,

    Statuses: serviceRequestDashboardFilters.Statuses,
    ServiceRequestAge: serviceRequestDashboardFilters.selectedDate ?? undefined,
    UnitId: serviceRequestDashboardFilters.UnitId[0]?.Id ?? undefined,
    TagIds: serviceRequestDashboardFilters.TagIds?.map((tag) => tag.value) ?? undefined,
    PropertyId: serviceRequestDashboardFilters.PropertyId ?? undefined,
    BuildingId: serviceRequestDashboardFilters.BuildingId ?? undefined,
    LevelId: serviceRequestDashboardFilters.LevelId ?? undefined,
    AssignedToServiceProviderId:
      serviceRequestDashboardFilters.AssignedToServiceProviderId ?? undefined,
    SubmittedFrom: serviceRequestDashboardFilters.SubmittedFrom ?? undefined,
    SubmittedTo: serviceRequestDashboardFilters.SubmittedTo ?? undefined,
    ServiceType: serviceRequestDashboardFilters.ServiceType ?? undefined,
    RequestType: serviceRequestDashboardFilters.RequestType ?? undefined,
    ItemTypeId: serviceRequestDashboardFilters.ItemTypeId ?? undefined,
  }
}

export const selectFilters = (state) => state.serviceRequestDashboardFilters;